import React from 'react';
import _ from "lodash";
import {connect} from "react-redux";

import {Grid} from "@material-ui/core";
import {displayErrorSnackBar, displaySuccessSnackBar} from "../../../../components/SnackbarProvider/actions";
import {PrimaryButton} from "../../../../components/Buttons";

import DepotSelectionModal from "../DepotSeletionModal";
import ModelPortfolioModal from "../../../Modelportfolios/components/ModelPortfoloModal";
import {ModelPortfolioResource} from "../../../../utils/api";
import {MODEL_PORTFOLIO_CREATE_ERROR_MESSAGE} from "../../../Modelportfolios/constants";
import {executeIfPathExist, getInvestmentDynamicPath} from "../../../InvestmentPlatform/utils";
import {getInvestmentPlatformSelector} from "../../../../utils/redaxSelectors";
import {SERVER_ERROR} from "../../../../utils/constants";
import {useCustomerInstrumentsDataContext} from "../../../../components/SelectForProductsComparisonModal/SelectForProductsComparisonModal";

const mapStateToProps = (state) => ({
  investmentPlatform: getInvestmentPlatformSelector(state)
});

export const SelectCustomerDepotsForMusterdepotModal = connect(mapStateToProps)(({investmentPlatform, customerId, onClose, dispatch, open}) => {
  const sharedData = useCustomerInstrumentsDataContext();

  const depots = React.useMemo(() => {
    return (sharedData.data || []).filter(
      (depot) => !depot.not_connected && !depot.is_manual)
      .map((depot) => ({
        ...depot,
        disabled: depot.is_model_portfolio || depot.is_private_investment,
        disabledReason: 'Aufgrund der Komplexität kann dieses Depot leider nicht als Musterdepot kopiert werden'
      }))
  }, [sharedData.updatedAt]);

  const [selectedItems, setSelectedItems] = React.useState({});
  const [mpDetailsModalOpened, setMpDetailsModalOpened] = React.useState(false);
  const [modelPortfolioCreationStatus, setModelPortfolioCreationStatus] = React.useState({
    loading: false,
    errors: null
  });

  if (!open) {
    return null
  }

  const handleContainerCheckboxChange = (depot) => {
    setSelectedItems({[depot.id]: depot});
  };

  const handleCreate = async (data, update) => {
    setModelPortfolioCreationStatus({
      loading: true,
      errors: null
    });

    try {
      const res = await ModelPortfolioResource.createModelPortfolio({
        ...data,
        assets: [],
        benchmarks: [],
        source_connect_depot: {portfolio_id: selectedDepot.id, customer_id: customerId}
      });

      setModelPortfolioCreationStatus({
        loading: false,
        errors: null
      });
      setMpDetailsModalOpened(false);
      onClose();

      executeIfPathExist(investmentPlatform.routes, 'MODELPORTFOLIO_OVERVIEW', path => {
        dispatch(displaySuccessSnackBar(
          <span>
            Ihr neues Musterdepot <b><a href={`/${getInvestmentDynamicPath()}${path.replace(':id', res)}`} target='_blank'>{data.name}</a></b> wurde erfolgreich gespeichert.
          </span>, null))
      });
    } catch (errors) {
      setModelPortfolioCreationStatus({
        loading: false,
        errors: _.isString(errors) ? errors : JSON.parse(_.get(errors, 'request.response', SERVER_ERROR))
      });

      dispatch(displayErrorSnackBar(MODEL_PORTFOLIO_CREATE_ERROR_MESSAGE))
    }
  };

  const selectedDepot = Object.values(selectedItems)[0];

  return (
    <>
      <DepotSelectionModal
        open={open}
        onClose={onClose}
        title={'Depotsimulation'}
        subHeader={'Wählen Sie bitte ein Depot, für welches eine Kopie als Depotsimulation in der Musterdepotfunktion erstellt werden soll.'}
        instrumentsData={sharedData}
        depots={depots}
        selectedItems={selectedItems}
        handleContainerCheckboxChange={handleContainerCheckboxChange}
        singleSelection
        actions={
          <Grid xs={12} sm={"auto"} item>
            <PrimaryButton
              text='Neues Musterdepot erstellen'
              disabled={!selectedDepot}
              onButtonClick={() => setMpDetailsModalOpened(true)}
              style={{width: '100%'}}
            />
          </Grid>
        }
      />
      <ModelPortfolioModal
        open={mpDetailsModalOpened}
        onClose={() => setMpDetailsModalOpened(false)}
        onModelPortfolioCreateClick={handleCreate}
        defaultStartDate={selectedDepot && selectedDepot.tracking_start_date}
        loading={modelPortfolioCreationStatus.loading}
        errors={modelPortfolioCreationStatus.errors}
        selectedModelPortfolio={selectedDepot}
        isCreate
      />
    </>
  )
});